export const fmtMoney = (v) => {
  if (v === null || v === undefined) return "—";
  const s = String(v);
  // Group thousands while preserving decimal precision.
  const [intPart, decPart] = s.split(".");
  const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return decPart !== undefined ? `${grouped}.${decPart}` : grouped;
};

export const fmtRate = (v) => {
  if (v === null || v === undefined) return "—";
  const n = parseFloat(v);
  return `${(n * 100).toFixed(2)}%`;
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  return new Date(iso).toISOString().slice(0, 10);
};
